import ApiClientBase from './ApiClientBase';

class ContactEndpoint extends ApiClientBase {
  apiUri = '/api/v2/hospitals';

  sendSubscriptionUpgradeRequest({ sourcePage }: { sourcePage: string }) {
    return this.apiCall(`/subscription_upgrade_request/`, 'post', {
      sourcePage,
    });
  }
}

const contact = new ContactEndpoint();

export default contact;
